<template>
  <div>
    <div
      v-for="item in items"
      :key="item.id"
      class="order-item-container"
      :style="!enableStore && 'border-color: #d9d9d9'"
    >
      <div style="display: flex; flex-direction: column">
        <p class="text" :style="!enableStore && 'color: #D9D9D9'">{{ item.name }}</p>
        <p v-if="item.prepaidCouponInfo && item.prepaidCouponInfo.description" id="description">
          {{ item.prepaidCouponInfo.description }}
        </p>
      </div>
      <div class="right-container">
        <p class="text" :style="!enableStore && 'color: #D9D9D9'">
          {{ item.price }} {{ item.currency }}
        </p>
        <div class="buttons-container">
          <v-icon icon class="quantity-icon" :disabled="!enableStore" @click="subOne(item)">
            remove_circle
          </v-icon>
          <div class="text" :style="!enableStore && 'color: #D9D9D9'" translate="no">
            {{ getNumOfTicket(item) }}
          </div>
          <v-icon icon class="quantity-icon" :disabled="!enableStore" @click="addOne(item)">
            add_circle
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_ORGANIZATION_ORDER_ITEMS } from '@/graphql/event.graphql'

export default {
  name: 'store-item-container',
  components: {},
  props: {
    organizationSlug: {
      type: String,
      default: null,
    },
    enableStore: {
      type: Boolean,
      default: false,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedItems: [...this.initialValues],
      items: null,
      loading: true,
    }
  },
  apollo: {
    getEventBySlug: {
      query: GET_ORGANIZATION_ORDER_ITEMS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          this.items = data.getOrganizationOrderItems
        }
      },
    },
  },
  methods: {
    getNumOfTicket(item) {
      return this.selectedItems.filter(i => i.id === item.id).length
    },
    addOne(item) {
      this.selectedItems.push(item)
      this.emitOrder()
    },
    subOne(item) {
      if (this.selectedItems.some(i => i.id === item.id)) {
        this.selectedItems.splice(
          this.selectedItems.findIndex(i => i.id === item.id),
          1,
        )
        this.emitOrder()
      }
    },
    emitOrder() {
      this.$emit('updateOrder', this.selectedItems)
    },
  },
}
</script>

<style scoped>
.order-item-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 24px;
  align-items: center;
  border-top: 2px solid #333;
  background: #fff;
  gap: 24px;
}
.right-container {
  display: flex;
  gap: 2.5rem;
}
.buttons-container {
  align-items: flex-start;
  gap: 1rem;
}
@media screen and (max-width: 480px) {
  .right-container {
    flex-direction: column;
  }
  .buttons-container {
    flex-direction: row;
  }
}
.text {
  color: #333;
  flex: 1;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%;
  letter-spacing: -0.72px;
}
#description {
  color: #999;
  flex: 1;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  white-space: pre-line;
  font-size: 1rem;
  font-style: normal;
  line-height: 120%;
  letter-spacing: -0.72px;
}
.quantity-icon {
  user-select: none;
  cursor: pointer;
}
</style>
